import React, { useContext } from 'react';
import Tabs from '../../core/components/Tabs/Tabs';
import DashboardApi from './api/DashboardApi';
import {
  CaseList,
  CustomerTransactions,
  MessagesTile,
  UpcomingPaymentsTile,
  PayAllTile,
  PayAllCustomerTransactionsTile,
  InfoHtml,
} from '../../logic/components';
import styles from './DashboardRoute.module.scss';
import TranslationService from '../../core/services/TranslationService';
import { useQuery } from 'react-query';
import { ActionStatusType } from '../../core/types/ActionStatusType';
import { Loader } from '../../core/components';
import { AppContext } from '../../AppContext';

type TabDataType = {
  moduleName: string;
  name: string;
  order: number;
};

type TabType = {
  debtorName: string;
  tabs: TabDataType[];
};

const DashboardRoute = () => {
  const context = useContext(AppContext);

  const tabIndex = '0';

  const tabs = useQuery<ActionStatusType<TabType>>('tabs', DashboardApi.getTabs, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const renderTab = (tabName: string) => {
    switch (tabName) {
      case 'CaseList':
        return (
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-8">
                <CaseList />
              </div>

              <div className="col-12 col-sm-4">
                {!context.isHideMypageCases && <PayAllTile />}
                <UpcomingPaymentsTile />
                <MessagesTile />
              </div>
            </div>
          </div>
        );
      case 'CustomerTransactions':
        return (
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-8">
                <CustomerTransactions />
              </div>

              <div className="col-12 col-sm-4">
                {!context.isHideMypageCases && <PayAllCustomerTransactionsTile />}
              </div>
            </div>
          </div>
        );
      default:
        <>No available tab</>;
    }
  };

  return (
    <>
      {tabs.isLoading ? (
        <Loader />
      ) : (
        <Tabs initIndex={tabIndex} className={styles.tabWrapper}>
          <Tabs.Nav className={styles.tabNav}>
            <div className="container">
              <div className={styles.tabNavItemWrapper}>
                {tabs.data?.data.tabs.map((tab, index) => (
                  <Tabs.Tab
                    id={`${tab.name.replace(/ /g, '')}Tab`}
                    key={tab.moduleName}
                    index={`${index}`}
                    className={styles.tabNavItem}
                    classNameActive={styles.tabNavItemActive}
                    label={TranslationService.translate(tab.name)}
                    component={renderTab(tab.moduleName)}
                    disableTabIndex={true}
                  />
                ))}
              </div>
            </div>
          </Tabs.Nav>

          {tabs.data?.data.debtorName ? (
            <InfoHtml debtorName={tabs.data.data.debtorName} />
          ) : (
            <h1 className={styles.visuallyHiddenHeading}>{TranslationService.translate('Welcome')}</h1>
          )}

          <Tabs.Panel className={styles.tabPanel}></Tabs.Panel>
        </Tabs>
      )}
    </>
  );
};

export default React.memo(DashboardRoute);
